import React, { useMemo } from 'react';
import { uniqueId } from 'lodash/fp';

export const Checkbox = ({ indeterminate, ...props }) => (
  <input
    {...props}
    type="checkbox"
    ref={input => {
      if (input) {
        input.indeterminate = props.checked && props.indeterminate;
      }
    }}
  />
);

export const LabeledCheckbox = props => {
  const { label, ariaLabel, className, checkBoxClassName, ...rest } = props;
  const id = useMemo(() => uniqueId('Checkbox_'), []);
  return (
    <label
      aria-label={ariaLabel}
      htmlFor={id}
      name={props.name}
      className={className}
    >
      <Checkbox id={id} className={checkBoxClassName || 'va-m'} {...rest} />
      {props.label || ''}
    </label>
  );
};
